import PrimeContactsPage from "../features/crm/PrimeContactsPage";

export default function PrimeContactsRoute() {
  return <PrimeContactsPage />;
}
